module.exports = __webpack_public_path__ + "img/icon_bill.1fd4f09b.png";